import React, { useEffect, useState } from 'react';

import { Navigate } from 'react-router-dom';
import { AccessPointData, PermissionData } from '../../api/types';
import { getMissingPermissions } from '../../utils/access';
import { isSiteEntrance } from '../../utils/utils';
import { AccessPointCard } from '../AccessPointCard/AccessPointCard';
import { ScanButton } from '../ScanButton/ScanButton';
import { AccessPointImpact } from './AccessPointImpact';
import { AccessPointPermissions } from './AccessPointPermissions';

interface AccessPointProps {
    accessInformation: AccessPointData;
    translations: Record<string, string>;
}

export const AccessPoint: React.FC<AccessPointProps> = ({ accessInformation, translations }) => {
    const [missingPermissions, setMissingPermissions] = useState<PermissionData[]>([]);

    useEffect(() => {
        const permissions = getMissingPermissions(accessInformation);
        setMissingPermissions(permissions);
    }, [accessInformation]);

    if (!accessInformation.accessSituation && missingPermissions.length === 1) {
        return (
            <Navigate
                to={`/accesspoint/${accessInformation.accessPointCode}/permissions/${missingPermissions[0].permissionCode}?scanbutton=true`}
                replace
            />
        );
    }

    return (
        <AccessPointCard
            accessInformation={accessInformation}
            Button={<ScanButton translations={translations} isRescan />}
            displayChildren={
                !isSiteEntrance(accessInformation) &&
                (!accessInformation.accessSituation || accessInformation.displayIMPACT)
            }
        >
            {!isSiteEntrance(accessInformation) && (
                <>
                    {!accessInformation.accessSituation && (
                        <AccessPointPermissions
                            accessInformation={accessInformation}
                            missingPermissions={missingPermissions}
                            translations={translations}
                        />
                    )}

                    {accessInformation.displayIMPACT && (
                        <AccessPointImpact
                            existingIMPACTs={accessInformation.existingIMPACTs}
                            translations={translations}
                        />
                    )}
                </>
            )}
        </AccessPointCard>
    );
};
